import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./SectrolSeminar.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import Footer from "../Home/Footer";
import SectoralSeminar1 from "../assets/img/SectoralSeminar1.png";
import SectoralSeminar2 from "../assets/img/SectoralSeminar2.png";
import SectoralSeminar3 from "../assets/img/SectoralSeminar3.png";
import SectoralSeminar4 from "../assets/img/SectoralSeminar4.png";
import SectoralSeminar5 from "../assets/img/SectoralSeminar5.png";
import SectoralSeminar6 from "../assets/img/SectoralSeminar6.png";
import SectoralSeminar7 from "../assets/img/SectoralSeminar7.png";
import SectoralSeminar8 from "../assets/img/SectoralSeminar8.png";
import SectoralSeminar9 from "../assets/img/SectoralSeminar9.png";
import SectoralSeminar10 from "../assets/img/SectoralSeminar10.png";
import SectoralSeminar11 from "../assets/img/SectoralSeminar11.png";
import SectoralSeminar12 from "../assets/img/SectoralSeminar12.png";
import SectoralSeminar13 from "../assets/img/SectoralSeminar13.png";
import SectoralSeminar14 from "../assets/img/SectoralSeminar14.png";
import SectoralSeminar15 from "../assets/img/SectoralSeminar15.png";
import SectoralSeminar16 from "../assets/img/SectoralSeminar16.png";
import WebinarSection from "../assets/img/webinar.png";

const SectoralSeminars = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const sectorlseminar = [
    {
      id: 1,
      title:
        'Webinar Titled "Exploring ways for Sustained Farmers Engagement in Production of Pulses"',
      date: "10th December 2024",
      location: "Online Webinar",
      image: SectoralSeminar1,
    },
    {
      id: 2,
      title: "Roundtable Discussion with Pulses Processors",
      date: "20th February 2025",
      location: "Nagpur, Maharashtra",
      image: SectoralSeminar2,
    },
    {
      id: 3,
      title: "Sectoral Seminar on “Utilization of Pulses Byproducts”",
      date: "21st February 2025",
      location: "Nagpur, Maharashtra",
      image: SectoralSeminar3,
    },
    {
      id: 4,
      title:
        "Webinar Titled- “Seed to Success: Boost your productivity with the right seed selection”",
      date: "25th April 2025",
      location: "Online Webinar",
      image: SectoralSeminar4,
    },
    {
      id: 5,
      title:
        "Sectoral Seminar on “Market-Aligned Pulse Cultivation: Strategic Planning for Profitable Kharif Sowing”",
      date: "14th May 2025",
      location: "Jalgaon, Maharashtra",
      image: SectoralSeminar5,
    },
    {
      id: 6,
      title:
        "Sectoral Seminar on “Market-Aligned Pulse Cultivation: Strategic Planning for Profitable Kharif Sowing” ",
      date: "16th May 2025 ",
      location: "Beed, Maharashtra",
      image: SectoralSeminar6,
    },
    {
      id: 7,
      title:
        "Sectoral Seminar on “Market-Aligned Pulse Cultivation: Strategic Planning for Profitable Kharif Sowing”",
      date: "20th May 2025",
      location: "Akola, Maharashtra",
      image: SectoralSeminar7,
    },
    {
      id: 8,
      title:
        "Sectoral Seminar on “Market-Aligned Pulse Cultivation: Strategic Planning for Profitable Kharif Sowing” ",
      date: "21st May 2025",
      location: "Washim, Maharashtra",
      image: SectoralSeminar8,
    },
    {
      id: 9,
      title:
        "Sectoral Seminar on “Market-Aligned Pulse Cultivation: Strategic Planning for Profitable Kharif Sowing”",
      date: "22nd May 2025",
      location: "Amaravati, Maharashtra",
      image: SectoralSeminar9,
    },
    {
      id: 10,
      title:
        "Sectoral Seminar on “Market-Aligned Pulse Cultivation: Strategic Planning for Profitable Kharif Sowing” ",
      date: "23rd May 2025",
      location: "Yavatmal, Maharashtra",
      image: SectoralSeminar10,
    },
    {
      id: 11,
      title:
        "Sectoral Seminar on “Market-Aligned Pulse Cultivation: Strategic Planning for Profitable Kharif Sowing”",
      date: "28th May 2025 ",
      location: "Nanded, Maharashtra",
      image: SectoralSeminar11,
    },
    {
      id: 12,
      title:
        "Sectoral Seminar on “Market-Aligned Pulse Cultivation: Strategic Planning for Profitable Kharif Sowing”",
      date: "29th May 2025",
      location: "Dharashiv, Maharashtra",
      image: SectoralSeminar12,
    },
    {
      id: 13,
      title:
        "Sectoral Seminar on “Market-Aligned Pulse Cultivation: Strategic Planning for Profitable Kharif Sowing”",
      date: "30th May 2025 ",
      location: "Latur, Maharashtra",
      image: SectoralSeminar13,
    },
    {
      id: 14,
      title:
        "Sectoral Seminar on “Market-Aligned Pulse Cultivation: Strategic Planning for Profitable Kharif Sowing”",
      date: "18th June 2025 ",
      location: "Jalna, Maharashtra",
      image: SectoralSeminar14,
    },
    {
      id: 15,
      title:
        "Sectoral Seminar on “Market-Aligned Pulse Cultivation: Strategic Planning for Profitable Kharif Sowing”  ",
      date: "19th June 2025 ",
      location: "Ahilyanagar, Maharashtra",
      image: SectoralSeminar15,
    },
    {
      id: 16,
      title:
        "Sectoral Seminar on “Market-Aligned Pulse Cultivation: Strategic Planning for Profitable Kharif Sowing”",
      date: "26th June 2025",
      location: "Satara, Maharashtra",
      image: SectoralSeminar16,
    },
  ];

  return (
    <div className="webinars">
      {/* Hero Section */}
      <div
        className="hero-section bg-fade"
        style={{
          background: `url(${WebinarSection}) no-repeat center center/cover`,
        }}
        data-aos="fade-up"
      >
        <h1 style={{ color: "#d4561a" }}>
          Join Our Seminars & Expand Your Knowledge
        </h1>
      </div>

      {/* Past Webinars with Slider */}
      <section className="past-webinars">
        <h2
          className="text-center separator-title"
          style={{ color: "#d4561a" }}
          data-aos="fade-up"
        >
          Sectoral Seminars/Workshops
        </h2>
        <div className="separator-line"></div>

        <div className="seminar-slider" style={{ padding: "40px" }}>
          <Swiper
            modules={[Autoplay]}
            pagination={false}
            slidesPerView={3}
            spaceBetween={20}
            loop={true}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            navigation={false}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            onSwiper={(swiper) => {
              const el = swiper.el;

              el.addEventListener("mouseenter", () => {
                swiper.autoplay?.stop?.();
              });

              el.addEventListener("mouseleave", () => {
                swiper.autoplay?.start?.();
              });

              el.addEventListener("click", () => {
                swiper.autoplay?.stop?.();
              });
            }}
          >
            {sectorlseminar.map((webinar) => (
              <SwiperSlide key={webinar.id}>
                <div className="seminar-card" data-aos="zoom-in">
                  <img
                    src={webinar.image}
                    alt={webinar.title}
                    className="seminar-image"
                  />
                  <div className="seminar-details">
                    <h3 className="seminar-title">{webinar.title}</h3>
                    <p className="seminar-date">
                      <strong>Date:</strong> {webinar.date}
                    </p>
                    <p className="seminar-location">
                      <strong>Location:</strong> {webinar.location}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SectoralSeminars;
